import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi, putApi, deleteApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
//import Genres from './components/genres/genres';
//import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';
import dayjs from 'dayjs';
import { DateTime } from 'luxon';
import { DatePicker } from "antd";

//import { Swiper, SwiperSlide } from 'swiper/react';
//import { Autoplay, Pagination, Navigation } from "swiper";
//import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';

//import './css/index.css';
//import './css/header.css';

export default class SupportInvoices extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			invoices: [],
			outgoings: [],
			show: false,
			//filenames: [],
			//servers: [],
			/*websites: [],
			ips: [],
			ip: '',*/
			/*sort: {
				column: '',
				order: ''
			}*/
			latest: {},
			month: {},
			create: {
				previous: false,
				company: '',
				invoiceid: '',
				date: dayjs(new Date()),
				total: 0,
			},
		};
    this.getInvoices = this.getInvoices.bind(this);
		this.show = this.show.bind(this);
		/*this.getWebsites = this.getWebsites.bind(this);
		this.updateWebsite = this.updateWebsite.bind(this);
		this.ipaddressAdd = this.ipaddressAdd.bind(this);
		this.ipaddressRemove = this.ipaddressRemove.bind(this);*/
		
		this.handleChange = this.handleChange.bind(this);
		this.setDate = this.setDate.bind(this);
		this.submitEvent = this.submitEvent.bind(this);
	
  };

  async componentDidMount() {
		//document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});

		//this.getWebsites();

		

		//this.setState({status: true});
		//this.enable();

		this.getInvoices();

	}

	componentWillUnmount() {
	}


	async getInvoices(/*column = 'l.ctime', order = 'DESC'*/) {
		/*let sort = this.state.sort;
		sort.column = column;
		sort.order = order;*/
		let params = new URLSearchParams();
		//params.append('column', column);
		//params.append('order', order);
		const x = await postApi('/v3/support/invoices', params);
		console.log(x.data);
		if( x.status === 200 ) this.setState({status: true, invoices: x.data.invoices?x.data.invoices:[], outgoings: x.data.outgoings?x.data.outgoings:[], latest: x.data.latest?x.data.latest:{}, month: x.data.month?x.data.month:{}});
	}

	async show(id) {
		if( id !== this.state.show ) {
			this.setState({show: id});
		} else {
			this.setState({show: false});
		}
	}


	handleChange(event) {
		var item = event.target.value;
		let create = this.state.create;
		//consoleLog(event.target.name, event.target.checked);
		
		if( event.target.name === "previous" ) create.previous = item;
		if( event.target.name === "company" ) create.company = item;
		if( event.target.name === "invoiceid" ) create.invoiceid = item;
		//if( event.target.name === "date" ) create.date = item;
		if( event.target.name === "total" ) create.total = parseFloat(item)?parseFloat(item):create.total;
		this.setState({create});
		
	}

	setDate(e) {
		let create = this.state.create;
		if( e ) {
			create.date = e._d || e['$d'];
		} else {
			create.date = 0;
		}
		this.setState({create});
	}


	async submitEvent(e) {
		if( e ) e.preventDefault();

		let params = new URLSearchParams();

		let create = this.state.create;
		
		for( let i in create ) {
			console.log(i, create[i]);
			params.append(i, i==='date'?Math.floor(new Date(create.date).getTime()/1000):create[i]);
		}
		
		const x = await putApi(`/v3/support/invoices`, params);
		if( x.status === 200 ) {
			//this.close();
			await this.getInvoices();
			this.setState({create: {
				previous: false,
				company: '',
				invoiceid: '',
				date: dayjs(new Date()),
				total: 0,
			}});
		} else {
			
		}
	}


	render() {
		
		const invoices = this.state.invoices.map((e,i) => {
			let date = new Date(e.ctime);
			return (
				<React.Fragment key={i}>
					<tr>
						<td onClick={()=>this.show(i)}>
							<div className="d-flex align-items-center">
								<div className="me-2 lh-1">
									<span className="avatar avatar-sm avatar-rounded">
										<img src={`https://cloud.ultrastream.io/${e.avatar}`} alt="" />
									</span>
								</div>
								<div>
									<p className="mb-0 fw-semibold">{e.title?e.title:e.username}</p>
									<p className="mb-0 fs-12 text-muted">{e.email}</p>
								</div>
							</div>
						</td>
						<td onClick={()=>this.show(i)}>
							<a href="javascript:void(0);" className="fw-semibold text-primary">#{e.id}</a>
						</td>
						<td onClick={()=>this.show(i)}>{moment(e.ctime).format("DD MMM YYYY")}</td>
						<td onClick={()=>this.show(i)}>
							{e.receipt==='0' ?
								<span className="badge bg-secondary-transparent fw-semibold fs-14">Not Paid</span>
							:
								<span className="badge bg-success-transparent fw-semibold fs-14">Paid</span>
							}
						</td>
						<td onClick={()=>this.show(i)}>£{e.price}</td>
						<td onClick={()=>this.show(i)}>£{e.total}</td>
						<td>
							<button className="btn btn-primary-light btn-icon btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Print"><i className="ri-printer-line"></i></button>
							<button className="btn btn-danger-light btn-icon ms-1 btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Delete"><i className="ri-delete-bin-5-line"></i></button>
						</td>
					</tr>
					{this.state.show === i &&
						<>
							{e.items.map((f,j) => {
								return (
									<tr key={j}>
										<td></td>
										<td colSpan={3}>{f.product} - {f.title}<br />
											{f.coupons.map((g,k) => {
												return (
													<React.Fragment key={k}><small>Coupon - {g.name} {g.enddate > 0 ? moment(g.enddate*1000).format("DD MMM YYYY") : ''}</small><br /></React.Fragment>
												)
											})}
										</td>
										<td>£{f.price}</td>
										<td>£{f.total}</td>
									</tr>
								)
							})}
						</>
					}
				</React.Fragment>
			)
		});


		const outgoings = this.state.outgoings.map((e,i) => {
			let date = new Date(e.ctime);
			return (
				<tr key={i}>
					<td>
						<div className="d-flex align-items-center">
							<div className="me-2 lh-1">
								<span className="avatar avatar-sm avatar-rounded">
									<img src={`https://cloud.ultrastream.io${e.avatar}`} alt="" />
								</span>
							</div>
							<div>
								<p className="mb-0 fw-semibold">{e.company}</p>
							</div>
						</div>
					</td>
					<td>
						<span className="fw-semibold text-primary">#{e.invoiceid}</span>
					</td>
					<td>{moment(e.ctime).format("DD MMM YYYY")}</td>
					<td>£{e.total}</td>
				</tr>
			)
		});

		let income = (this.state.latest.income-this.state.month.income) / ( this.state.month.income / 100 );
		let outgoing = (this.state.latest.outgoing-this.state.month.outgoing) / ( this.state.month.outgoing / 100 );
		let total = (this.state.latest.total-this.state.month.total) / ( this.state.month.total / 100 );
		let users = (this.state.latest.users-this.state.month.users) / ( this.state.month.users / 100 );
		let users_active = (this.state.latest.users_active-this.state.month.users_active) / ( this.state.month.users_active / 100 );
		let services = (this.state.latest.services-this.state.month.services) / ( this.state.month.services / 100 );
		console.log(income, outgoing, total, users, users_active, services);
		
		return (
			<>

				<div className="d-sm-flex d-block align-items-center justify-content-between page-header-breadcrumb">
					<h4 className="fw-medium mb-0">System</h4>
					<div className="ms-sm-1 ms-0">
						<nav>
							<ol className="breadcrumb mb-0">
								{/*<li className="breadcrumb-item"><a href="javascript:void(0);">Ui Elements</a></li>*/}
								<li className="breadcrumb-item active" aria-current="page">System</li>
							</ol>
						</nav>
					</div>
				</div>

				{this.state.status &&
					<div className="main-content app-content">
						 
						<div className="container-fluid">

							<div className="my-4">
								<Row>
									
									<Col xs={12}>
										<div className="row row-cols-xxl-5 row-cols-xl-3 row-cols-md-2">
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Sales</p>
																<h3 className="mb-0">£{this.state.latest.total}</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-primary-transparent ms-auto">
																<FontAwesomeIcon icon="cart-shopping" className="fs-20" />
															</div>
														</div>
														{/*income, outgoing, total, users, users_active, services*/}
														<div className="d-flex mt-2">
															{parseInt(total) < 0 &&
																<span className="badge  bg-danger-transparent rounded-pill">
																	-{total}% <FontAwesomeIcon icon="arrow-down" />
																</span>
															}
															{parseInt(total) > 0 &&
																<span className="badge bg-primary-transparent rounded-pill">
																	+{total}% <FontAwesomeIcon icon="arrow-up" />
																</span>
															}
															<span>&nbsp;</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Revenue</p>
																<h3 className="mb-0">£{this.state.latest.income}</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-secondary-transparent ms-auto">
																<FontAwesomeIcon icon="box-archive" className="fs-20" />
															</div>
														</div>
														{/*income, outgoing, total, users, users_active, services*/}
														<div className="d-flex mt-2">
															{parseInt(income) < 0 &&
																<span className="badge  bg-danger-transparent rounded-pill">
																	-{income}% <FontAwesomeIcon icon="arrow-down" />
																</span>
															}
															{parseInt(income) > 0 &&
																<span className="badge bg-primary-transparent rounded-pill">
																	+{income}% <FontAwesomeIcon icon="arrow-up" />
																</span>
															}
															<span>&nbsp;</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium mb-1 text-muted">Total Expenses</p>
																<h3 className="mb-0">£{this.state.latest.outgoing}</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-warning-transparent ms-auto">
																<FontAwesomeIcon icon="sterling-sign" className="fs-20" />
															</div>
														</div>
														{/*income, outgoing, total, users, users_active, services*/}
														<div className="d-flex mt-2">
															{parseInt(outgoing) < 0 &&
																<span className="badge  bg-danger-transparent rounded-pill">
																	-{outgoing}% <FontAwesomeIcon icon="arrow-down" />
																</span>
															}
															{parseInt(outgoing) > 0 &&
																<span className="badge bg-primary-transparent rounded-pill">
																	+{outgoing}% <FontAwesomeIcon icon="arrow-up" />
																</span>
															}
															<span>&nbsp;</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Total Services</p>
																<h3 className="mb-0">{this.state.latest.services}</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-info-transparent ms-auto">
																<FontAwesomeIcon icon="bag-shopping" className="fs-20" />
															</div>
														</div>
														{/*income, outgoing, total, users, users_active, services*/}
														<div className="d-flex mt-2">
															{parseInt(services) < 0 &&
																<span className="badge  bg-danger-transparent rounded-pill">
																	-{services}% <FontAwesomeIcon icon="arrow-down" />
																</span>
															}
															{parseInt(services) > 0 &&
																<span className="badge bg-primary-transparent rounded-pill">
																	+{services}% <FontAwesomeIcon icon="arrow-up" />
																</span>
															}
															<span>&nbsp;</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col card-background flex-fill">
												<div className="card custom-card">
													<div className="card-body">
														<div className="d-flex">
															<div>
																<p className="fw-medium text-muted mb-1">Active Subscribers</p>
																<h3 className="mb-0">{this.state.latest.users_active}</h3>
															</div>
															<div className="avatar avatar-md br-4 bg-danger-transparent ms-auto">
																<i className="bi bi-bell fs-20"></i>
																<FontAwesomeIcon icon="bell" className="fs-20" />
															</div>
														</div>
														{/*income, outgoing, total, users, users_active, services*/}
														<div className="d-flex mt-2">
															{parseInt(users_active) < 0 &&
																<span className="badge  bg-danger-transparent rounded-pill">
																	-{users_active}% <FontAwesomeIcon icon="arrow-down" />
																</span>
															}
															{parseInt(users_active) > 0 &&
																<span className="badge bg-primary-transparent rounded-pill">
																	+{users_active}% <FontAwesomeIcon icon="arrow-up" />
																</span>
															}
															<span>&nbsp;</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										
										<div className="card custom-card overflow-hidden">
											<div className="card-header flex-between justify-content-between">
												<div className="card-title">Invoices</div>
											</div>
											<div className="card-body">
												<div className="table-responsive">
													<table className="table text-nowrap table-hover">
														<thead>
															<tr>
																<th scope="col">Client</th>
																<th scope="col">Invoice ID</th>
																<th scope="col">Issued Date</th>
																<th scope="col">Status</th>
																<th scope="col">Amount</th>
																
																
																
																<th scope="col">Action</th>
															</tr>
														</thead>
														<tbody>
															{invoices}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</Col>

									<Col xs={12}>
										
										<div className="card custom-card overflow-hidden">
											<div className="card-header flex-between justify-content-between">
												<div className="card-title">Outgoing Invoices</div>
											</div>
											<div className="card-body" style={{minHeight: 400}}>
												<div className="table-responsive">

													<form className="row row-cols-lg-auto g-3 align-items-center">
														<div className="col">
															<select className="form-select" id="inlineFormSelectPref">
																<option selected="">New...</option>
																<option value="1">One</option>
																<option value="2">Two</option>
																<option value="3">Three</option>
																</select>
															<label className="visually-hidden" htmlFor="company">Company</label>
														</div>
														<div className="col-12">
															<div className="input-group">
																<div className="input-group-text">@</div>
																<input type="text" name="company" className="form-control" id="company" value={this.state.create.company} onChange={this.handleChange} placeholder="Company" />
															</div>
														</div>
														<div className="col-12">
															<input type="text" name="invoiceid" className="form-control" id="invoiceid" value={this.state.create.invoiceid} onChange={this.handleChange} placeholder="Invoice ID" />
														</div>
														<div className="col-12">
															<DatePicker defaultValue={this.state.create.date} onChange={this.setDate} getPopupContainer={(triggerNode)=>{return triggerNode.parentNode;}} onFocus={e => e.target.blur()} />
														</div>
														<div className="col-12">
															<div className="input-group">
																<div className="input-group-text">£</div>
																<input type="number" name="total" className="form-control" id="total" value={this.state.create.total} onChange={this.handleChange} placeholder="0.00" />
															</div>
														</div>

														<div className="col-12">
															<button type="submit" className="btn btn-primary" onClick={(e)=>this.submitEvent(e)}>Add</button>
														</div>
												</form>

													<table className="table text-nowrap table-hover">
														<thead>
															<tr>
																<th scope="col">Company</th>
																<th scope="col">Invoice ID</th>
																<th scope="col">Issued Date</th>
																<th scope="col">Total</th>
															</tr>
														</thead>
														<tbody>
															{outgoings}
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</Col>
								</Row>
							</div>
						</div>
					</div>
				}
			</>
		);
	}
}
